const t = {
  name: "OauthScalability",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8.4,7H12V5H5v7h2V8.4l4,4V24c0,2.8,2.2,5,5,5h11.6l3,3H27v2h7v-7h-2v3.6l-3-3V16c0-2.8-2.2-5-5-5H12.4L8.4,7
			z M13,24V13h11c1.7,0,3,1.3,3,3v11H16C14.3,27,13,25.7,13,24z"/>
		<path class="st0" d="M31,0H0v31c0,5,4,9,9,9h31V9C40,4,36,0,31,0z M2,31V2h29c3.9,0,7,3.1,7,7v29H9C5.1,38,2,34.9,2,31z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as OauthScalability
};
